<template>
  <component :is="noLink ? 'div' : 'a'" class="recipe-preview-simple" :href="recipe.url" :title="recipe.name">
    <figure class="image is-square">
      <responsive-image :desktop="recipe.desktop_image" :tablet="recipe.tablet_image" :mobile="recipe.mobile_image" :blurred="recipe.blurred_image" lazy/>
      <div class="overlay">
        <span>{{recipe.name}}</span>
      </div>
    </figure>
  </component>

</template>

<script>
import ResponsiveImage from '../ResponsiveImage.vue'

export default {
  props: {
    recipe: Object,
    noLink: {type: Boolean, default: false}
  },

  components: {
    ResponsiveImage
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/recipe/PreviewSimple.vue